import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid, makeStyles } from '@material-ui/core';
import { contaReceberModais } from 'app/main/contareceber/components/modal/contaReceberModais';
import { ContaReceberContext } from 'app/main/contareceber/contaReceberContext';
import contaReceberApi from 'app/services/api/contaReceberApi';
import * as Actions from 'app/store/actions';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { useFormik } from 'formik';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { ConciliacaoContext } from '../ConciliacaoContext';
import {
  BotaoConciliar,
  BotaoDesconciliar,
  ContainerExtratoForm,
} from '../containers/ContainerLancamentoExtratoBancario';
import FormularioLancamentoReceita from '../forms/FormularioLancamentoReceita';
import CadastroContaReceberModal from '../modal/CadastroContaReceberModal';
import { ConciliacaoModal } from '../modal/ConciliacaoModal';
import PesquisaContaPagarModal from '../pesquisas/contaPagar/PesquisaContaPagarModal';
import PesquisaContaReceberModal from '../pesquisas/contaReceber/PesquisaContaReceberModal';
import VisualizacaoReceita from '../visualizacao/VisualizacaoReceita';

const useStyles = makeStyles((theme) => ({
  btnContainer: {
    alignSelf: 'center',
  },
}));

const ContentLancamentoReceita = ({
  extrato,
  handlerVisualizarDespesa,
  handlerEditarDespesa,
  handlerLancarContaPagar,
  handlerConciliar,
  handlerDesconciliar,
  index,
}) => {
  const [modalConciliacao, setModalConciliacao] = useContext(ConciliacaoContext).modal;
  const [, setContaReceber] = useContext(ConciliacaoContext).contaReceber;
  const [loading, setLoading] = useContext(ContaReceberContext).loading;
  const [, setConciliacao] = useContext(ConciliacaoContext).conciliacao;
  const [, setContaReceberAtual] = useContext(ContaReceberContext).contaReceberAtual;
  const [, setModalContaReceber] = useContext(ContaReceberContext).modal;
  const [extratoSelecionado, setExtratoSelecionado] = useContext(ConciliacaoContext).extratoSelecionado;
  const [formularioLancamentoReceita] = useContext(ConciliacaoContext).formularioLancamentoReceita;
  const [conciliacoes, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;

  const showError = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'error' }));
  };

  useReduxLoading(loading);

  const classes = useStyles();

  const getInitialValues = (registro) => ({
    ...registro,
    idReceita: registro?.receita?.id,
    clienteReceita: registro?.receita?.cliente?.id,
    formaRecebimentoReceita: registro?.receita?.formaRecebimento,
    categoriaReceita: registro?.receita?.categoria?.id,
    valorReceita: Math.abs(extrato?.valor),

    tipoLancamento: registro?.tipoLancamento || 'RECEITAS',

    idDespesa: registro?.despesa?.id,
    fornecedorDespesa: registro?.despesa?.fornecedor?.id,
    categoriaDespesa: registro?.despesa?.categoria?.id,
    valorDespesa: registro?.despesa?.valor,
    formaPagamentoDespesa: registro?.despesa?.formaPagamento,
    numeroChequeDespesa: registro?.despesa?.numeroCheque,
  });

  const FormReceitaSchema = yup.object().shape({
    clienteReceita: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('o cliente')),
    formaRecebimentoReceita: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('a forma de recebimento')),
    categoriaReceita: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('a categoria')),
    valorReceita: yup
      .string()
      .nullable()
      .required(mensagemCampoObrigatorio('o valor')),
    fornecedorDespesa: yup
      .string()
      .nullable()
      .test('validaFornecedorDespesa', mensagemCampoObrigatorio('o fornecedor'), function(fornecedorDespesa) {
        const { tipoLancamento } = this.parent;

        return tipoLancamento !== 'RECEITAS_DESPESAS' || !!fornecedorDespesa;
      }),
    categoriaDespesa: yup
      .string()
      .nullable()
      .test('validaCategoriaDespesa', mensagemCampoObrigatorio('a categoria'), function(categoriaDespesa) {
        const { tipoLancamento } = this.parent;

        return tipoLancamento !== 'RECEITAS_DESPESAS' || !!categoriaDespesa;
      }),
    valorDespesa: yup
      .string()
      .nullable()
      .test('validaValorDespesa', mensagemCampoObrigatorio('o valor'), function(valorDespesa) {
        const { tipoLancamento } = this.parent;

        return tipoLancamento !== 'RECEITAS_DESPESAS' || !!valorDespesa;
      }),
    formaPagamentoDespesa: yup
      .string()
      .nullable()
      .test('validaFormaPagamentoDespesa', mensagemCampoObrigatorio('a forma de pagamento'), function(
        formaPagamentoDespesa
      ) {
        const { tipoLancamento } = this.parent;

        return tipoLancamento !== 'RECEITAS_DESPESAS' || !!formaPagamentoDespesa;
      }),
    numeroChequeDespesa: yup
      .string()
      .nullable()
      .test('validaNumeroChequeDespesa', mensagemCampoObrigatorio('o número do cheque'), function(numeroChequeDespesa) {
        const { formaPagamentoDespesa, tipoLancamento } = this.parent;

        return tipoLancamento !== 'RECEITAS_DESPESAS' || formaPagamentoDespesa !== 'CHEQUE' || !!numeroChequeDespesa;
      }),
  });

  const handlerConciliarReceita = async () => {
    let conciliacaoAux = conciliacoes.filter((c) => c.id === extrato.id)[0];
    if (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS') {
      conciliacaoAux.contaPagarList = [
        {
          fornecedor: formik?.values?.fornecedorDespesa,
          categorias: [formik?.values?.categoriaDespesa],
          valor: formik?.values?.valorDespesa,
          formaPagamento: formik?.values?.formaPagamentoDespesa,
          numeroCheque: formik?.values?.numeroChequeDespesa,
          formulario: true,
        },
      ];
    }

    conciliacaoAux.contaReceberList = [
      {
        cliente: formik?.values?.clienteReceita,
        categorias: [formik?.values?.categoriaReceita],
        valor: formik?.values?.valorReceita,
        formaRecebimento: formik?.values?.formaRecebimentoReceita,
        formulario: true,
      },
    ];
    await handlerConciliar(conciliacaoAux);
    formik.resetForm(getInitialValues);
  };

  const formik = useFormik({
    initialValues: getInitialValues(formularioLancamentoReceita),
    validationSchema: FormReceitaSchema,
    onSubmit: handlerConciliarReceita,
    validateOnChange: true,
    validateOnBlur: true,
  });

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const fetchContaReceber = async (id) => {
    setLoading(true);
    try {
      const response = await contaReceberApi.buscarPorId(id);

      const contaReceber = response?.data;

      if (
        contaReceber?.baixa?.juros ||
        contaReceber?.baixa?.multa ||
        contaReceber?.baixa?.desconto ||
        contaReceber?.baixa?.correcaoMonetaria
      ) {
        contaReceber.baixa.acrescimoDesconto = true;
      }

      setContaReceber(contaReceber);
      setContaReceberAtual(contaReceber);
      return response?.data;
    } catch (err) {
      console.error(err);
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handlerLimparInformacoesFormulario = () => {
    if (extrato.contaReceberList && extrato.contaReceberList?.length !== 0 && !extrato.contaReceberList[0].formulario) {
      if (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS') {
        if (extrato.contaPagarList && extrato.contaPagarList?.length !== 0) {
          handlerLimparInformacoesVisualizacao(extrato.contaReceberList[0], extrato.contaPagarList[0]);
        } else {
          handlerLimparInformacoesVisualizacao(extrato.contaReceberList[0]);
        }
      } else {
        handlerLimparInformacoesVisualizacao(
          extrato.contaReceberList[0],
          undefined,
          extrato.contaReceberList?.length > 1
        );
      }
    } else {
      formik.resetForm(getInitialValues);
    }
  };

  const handlerLancarConta = () => {
    abrirModalContaReceber();
  };

  const handlerVisualizarReceita = async (receita) => {
    fetchContaReceber(receita.id);
    setModalContaReceber(contaReceberModais.visualizarContaReceber);
  };

  const handlerPesquisarDespesa = () => {
    setLoading(true);
    setExtratoSelecionado(extrato);
    setModalConciliacao(ConciliacaoModal.pesquisaContaPagar);
    setLoading(false);
  };

  const handlerPesquisarReceita = () => {
    setLoading(true);
    setExtratoSelecionado(extrato);
    setModalConciliacao(ConciliacaoModal.pesquisaContaReceber);
    setLoading(false);
  };

  const handlerCriarTransferencia = () => {
    setLoading(true);

    setConciliacoes(
      conciliacoes.map((c) => {
        if (c.id === extrato.id) {
          c.criarTransferencia = true;
        }
        return c;
      })
    );

    setLoading(false);
  };

  const abrirModalContaReceber = () => {
    setLoading(true);
    setExtratoSelecionado(extrato);
    setConciliacao(extrato);
    setModalConciliacao(ConciliacaoModal.cadastroContaReceberModal);
    setLoading(false);
  };

  const editarReceita = async (id) => {
    await fetchContaReceber(id);
    abrirModalContaReceber();
  };

  const handlerEditarReceita = async (receita) => {
    if (!receita.baixas || !receita?.situacao === 'PARCIAL') {
      editarReceita(receita.id);
    } else {
      showError('Não é possível editar a receita pois ela está baixada ou parcialmente baixada.');
    }
  };

  const carregaContasReceberNoCard = () => {
    setModalConciliacao('');
    conciliacoes
      .filter((c) => c.id === extratoSelecionado.id)
      .forEach((c) => {
        c.contaReceberList = extratoSelecionado.contaReceberList;
      });
    setConciliacoes(conciliacoes);
    setExtratoSelecionado({});
  };

  const carregaContasPagarNoCard = () => {
    setModalConciliacao('');
    conciliacoes
      .filter((c) => c.id === extratoSelecionado.id)
      .forEach((c) => {
        c.contaPagarList = extratoSelecionado.contaPagarList;
      });
    setConciliacoes(conciliacoes);
    setExtratoSelecionado({});
  };

  const handlerLimparInformacoesVisualizacao = (receitaSelecionada, despesaSelecionada, lista) => {
    if (!!receitaSelecionada) {
      const listaReceita = extrato.contaReceberList.filter((conta) => conta.id !== receitaSelecionada.id);

      if (listaReceita.length > 0 && !lista) {
        extrato.contaReceberList = listaReceita;
      } else {
        delete extrato.contaReceberList;
      }
    }

    if (!!despesaSelecionada) {
      const listaDespesa = extrato.contaPagarList.filter((conta) => conta.id !== despesaSelecionada.id);

      if (listaDespesa.length > 0 && !lista) {
        extrato.contaPagarList = listaDespesa;
      } else {
        delete extrato.contaPagarList;
      }
    }

    setExtratoSelecionado(extrato);
    carregaContasReceberNoCard();
  };

  const visualizacaoUnica =
    extrato?.contaReceberList && extrato?.contaReceberList.length === 1 && !extrato?.contaReceberList[0].formulario;

  const visualizacaoLista = extrato?.contaReceberList && extrato?.contaReceberList.length > 1;

  const visualizacao =
    (visualizacaoUnica || visualizacaoLista) && formik?.values?.tipoLancamento !== 'RECEITAS_DESPESAS';

  const visualizacaoTransferencia = extrato?.criarTransferencia && !extrato?.transferenciaBancaria;

  return extrato &&
    !extrato?.transferenciaBancaria &&
    extrato?.valor != null &&
    extrato?.valor >= 0 &&
    (!extrato?.contaPagarList ||
      (!!extrato?.contaPagarList &&
        (formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS' || !!extrato?.contaReceberList))) &&
    !visualizacaoTransferencia ? (
    <>
      <Grid item xs={2} className={classes.btnContainer}>
        {!extrato?.id ? null : extrato.conciliado !== true ? (
          <BotaoConciliar
            onClick={() => {
              extrato.contaReceberList ? handlerConciliar(extrato) : formik.submitForm();
            }}
          />
        ) : (
          <BotaoDesconciliar
            onClick={() => {
              handlerDesconciliar(extrato);
            }}
          />
        )}
      </Grid>
      <Grid item xs={5}>
        <ContainerExtratoForm
          values={conciliacoes[index]}
          formik={formik}
          handlerLancarConta={handlerLancarConta}
          handlerPesquisar={handlerPesquisarReceita}
          handlerVisualizar={handlerVisualizarReceita}
          handlerCriarTransferencia={handlerCriarTransferencia}
          handlerLimparInformacoes={handlerLimparInformacoesFormulario}
          handlerEditar={handlerEditarReceita}
          formReceitaDespesa={formik?.values?.tipoLancamento === 'RECEITAS_DESPESAS'}
          temPermissaoParaVisualizar={permissaoUtils.contaReceber().visualizar}
          temPermissaoParaEditar={permissaoUtils.contaReceber().editar}
          temPermissaoParaCriar={permissaoUtils.contaReceber().cadastrar}
        >
          {visualizacao ? (
            <VisualizacaoReceita
              extrato={extrato}
              contaReceberList={extrato.contaReceberList}
              contaPagarList={extrato.contaPagarList}
              conciliado={extrato.conciliado}
              handlerVisualizarReceita={handlerVisualizarReceita}
              handlerLimparInformacoes={handlerLimparInformacoesVisualizacao}
              handlerVisualizarDespesa={handlerVisualizarDespesa}
              exibirTooltipSemCorrespondencia={extrato.valor === 0}
              temPermissaoParaVisualizarReceita={permissaoUtils.contaReceber().visualizar}
              temPermissaoParaVisualizarDespesa={permissaoUtils.contaPagar().visualizar}
            />
          ) : (
            <FormularioLancamentoReceita
              index={index}
              formik={formik}
              extrato={extrato}
              handlerPesquisarReceita={handlerPesquisarReceita}
              handlerPesquisarDespesa={handlerPesquisarDespesa}
              handlerVisualizarReceita={handlerVisualizarReceita}
              handlerEditarReceita={handlerEditarReceita}
              handlerLimparInformacoesVisualizacao={handlerLimparInformacoesVisualizacao}
              handlerVisualizarDespesa={handlerVisualizarDespesa}
              handlerEditarDespesa={handlerEditarDespesa}
              handlerLancarContaReceber={handlerLancarConta}
              handlerLancarContaPagar={handlerLancarContaPagar}
            />
          )}
        </ContainerExtratoForm>
      </Grid>
      {modalConciliacao === ConciliacaoModal.pesquisaContaReceber && extratoSelecionado?.id === extrato.id && (
        <PesquisaContaReceberModal onSubmit={carregaContasReceberNoCard} />
      )}

      {modalConciliacao === ConciliacaoModal.cadastroContaReceberModal && (
        <CadastroContaReceberModal origemConciliacao />
      )}

      {modalConciliacao === ConciliacaoModal.pesquisaContaPagar && extratoSelecionado?.id === extrato.id && (
        <PesquisaContaPagarModal onSubmit={carregaContasPagarNoCard} />
      )}
    </>
  ) : null;
};

export default ContentLancamentoReceita;
